import React from "react";
import moduleStyle from "./FormFieldLabel.module.css";
import Tooltip from "ui/modules/Tooltip";
import { is_empty } from "utils/validations";

export const FormFieldLabel = ({
  formKey,
  formKeys = {},
  required = false,
  classes = [],
}) => {
  const labelClassName = classes?.labelClassName ?? "";
  const spanClassName = classes.spanClassName ?? "ml-1";
  if (is_empty(formKeys)) return null;
  return (
    <div className={`d-flex align-items-center`}>
      <div className={`${moduleStyle.label} ${labelClassName}`}>
        {formKeys[formKey]?.label}
        {required && <span className={`text-danger ${spanClassName}`}>*</span>}
      </div>
      {formKeys[formKey]?.tooltipText && (
        <Tooltip text={formKeys[formKey]?.tooltipText} />
      )}
    </div>
  );
};
